module.exports = __webpack_public_path__ + "static/img/013.6f261a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/yqs/013.png
// module id = 6ix/
// module chunks = 0